import { Helmet } from "react-helmet";
import * as Constants from '../../../Common/Constants'

const ContactMetaAr = () => {

    return (
        <Helmet>
            <title> اتصل Augnito | استكشف الحل الأمثل لمتطلباتك في المجال السريري </title>
            <link rel="shortcut icon" href={Constants.SITE_URL + "/favicon.ico"} />
            <link rel="icon" href={Constants.SITE_URL + "/favicon.ico"} />
            <link rel="profile" href="https://gmpg.org/xfn/11" />
            <meta name="description" content="مساعدة الخبراء في مجال برامج النسخ الطبي المتطورة. تواصل معنا للاستفسار عن حلول الرعاية الصحية التي تعتمد على الذكاء الاصطناعي والمصممة خصيصًا لأنظمة الرعاية الصحية العربية." />
            <meta charset="UTF-8" />
            <meta name="language" content="ar" />
            <link rel="canonical" href={Constants.SITE_URL + "/ar/contact-us"} />
            <meta property="og:url" content={Constants.SITE_URL + "/ar/contact-us"} />
            <meta property="og:title" content="اتصل Augnito | استكشف الحل الأمثل لمتطلباتك في المجال السريري" />
            <meta property="og:description" content="مساعدة الخبراء في مجال برامج النسخ الطبي المتطورة. تواصل معنا للاستفسار عن حلول الرعاية الصحية التي تعتمد على الذكاء الاصطناعي والمصممة خصيصًا لأنظمة الرعاية الصحية العربية." />
            <meta property="og:image" content={Constants.SITE_URL + "/logo192.png"} />
            <meta property="og:type" content="website" />
            <meta property="og:locale" content="en_US" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:url" content={Constants.SITE_URL + "/ar/contact-us"}/>
            <meta name="twitter:site" content="@augnito" />
            <meta name="twitter:title" content="اتصل Augnito | استكشف الحل الأمثل لمتطلباتك في المجال السريري" />
            <meta name="twitter:description" content="مساعدة الخبراء في مجال برامج النسخ الطبي المتطورة. تواصل معنا للاستفسار عن حلول الرعاية الصحية التي تعتمد على الذكاء الاصطناعي والمصممة خصيصًا لأنظمة الرعاية الصحية العربية." />
            <meta name="twitter:creator" content="@augnito" />
            <meta name="twitter:image" content={Constants.SITE_URL + "/logo192.png"} />
            <meta name="copyright" content="Augnito" />
            <meta name="owner" content="Augnito" />
            <link rel="alternate" href={Constants.SITE_URL} hreflang="en-us" />
            <link rel="alternate" hreflang="ar" href={Constants.SITE_URL + "/ar/contact-us"} />
            <meta name="google-site-verification" content="TivMeqLjfaI6TIRsSF0Kqw0J8UnBPK2PToomuQRwVCs" />
        </Helmet>
    );
};

export default ContactMetaAr;
